var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row share-user-row"},[_c('div',{staticClass:"col-7",domProps:{"innerHTML":_vm._s(_vm.getUserTitle)}}),_c('div',{staticClass:"col-5"},_vm._l((_vm.theRoles),function(role){return _c('option',{key:role.id,domProps:{"value":role.id}},[_vm._v(_vm._s(role.name))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }